import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NestedSidebarMenu = ({ el }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <button
        className="btn sidebar-menu-button !tw-text-secondary !tw-px-3 sidebar-js-collapse hover:!tw-text-white"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setOpen(!open);
        }}
      >
        <i className="sidebar-menu-icon--left !tw-text-[#B0B1B4] material-icons tw-size-6">
          {el.icon}
        </i>
        {el?.title}
        <span className="material-icons !tw-text-xl">
          {open ? "arrow_drop_up" : "arrow_drop_down"}
        </span>
      </button>
      {/* {open && ( */}
      <div
        className={`tw-overflow-hidden tw-transition-all tw-duration-300 ${
          open
            ? "tw-max-h-[500px] tw-opacity-100 tw-ms-1 tw-my-2 "
            : "tw-max-h-0 tw-opacity-0"
        }`}
      >
        {el?.subLinks?.map((sub) => (
          <Link
            key={sub.link}
            to={sub.link}
            className={`sidebar-menu-button hover:!tw-text-white !tw-ps-3 !tw-pe-0 ${
              location.pathname === sub.link ? "sidebar-active-color" : ""
            }`}
          >
            <i className="sidebar-menu-icon--left !tw-text-[#B0B1B4] material-icons tw-size-6">
              {sub.icon}
            </i>
            {sub.title}
          </Link>
        ))}
      </div>

      {/* )} */}
    </>
  );
};

export default NestedSidebarMenu;
